module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-dialog', {
    ref: "dialog",
    staticClass: "lookup-dialog",
    attrs: {
      "append-to-body": true,
      "title": _vm.title,
      "height": _vm.computedHeight,
      "size": _vm.size,
      "hide-divider": "",
      "show-column": "",
      "slide-layout": _vm.column ? 'column' : '',
      "column-width-ratio": _vm.ratio
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "lookup-row"
  }, [_c('rt-node', {
    attrs: {
      "show-icon": false
    }
  }, [_c('div', {
    ref: "node-header",
    staticClass: "lookup-node-header"
  }, [(_vm.entityLabels.length > 0) ? _c('rt-radio-group', {
    on: {
      "change": _vm.changeRadioHandler
    },
    model: {
      value: (_vm.entityIndex),
      callback: function($$v) {
        _vm.entityIndex = $$v
      },
      expression: "entityIndex"
    }
  }, _vm._l((_vm.entityLabels), function(entryLabel, index) {
    return _c('rt-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n            " + _vm._s(entryLabel) + "\n          ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "node-header-right",
    staticClass: "lookup-node-header-right"
  }, [(_vm.tableSearch) ? _c('rt-search', {
    attrs: {
      "clearable": _vm.clearable,
      "more": false,
      "placeholder": _vm.searchPlaceholder
    },
    on: {
      "on-search": _vm.search,
      "clear": _vm.clearQueryValue
    },
    model: {
      value: (_vm.queryValue),
      callback: function($$v) {
        _vm.queryValue = $$v
      },
      expression: "queryValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.multiple && _vm.showSelected && !_vm.column) ? _c('rt-checkbox', {
    on: {
      "change": _vm.changeCheckboxHandler
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$tx('仅显示已选项', 'xpc.lookup.showSelected')) + "\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('rt-table', {
    ref: "table",
    class: {
      'is-single': !_vm.multiple,
      'table-footer-shadow': _vm.tableFooterShadow
    },
    attrs: {
      "keep-selected": _vm.keepSelected,
      "fetch": _vm.fetchData,
      "page-size": 10,
      "total-record": _vm.totalRecords,
      "row-key": _vm.getRowKeys,
      "radio": !_vm.multiple,
      "page-layout": "total, sizes, prev, pager, next"
    },
    on: {
      "select": _vm.select,
      "select-all": _vm.selectAll,
      "row-click": _vm.onTableRowClick,
      "load-complete": _vm.onTableLoadComplete,
      "clear-selection": _vm.clearSelection
    }
  }, _vm._l((_vm.computedDisplayFields), function(item, index) {
    return _c('rt-table-column', {
      key: index,
      attrs: {
        "prop": item.prop,
        "label": item.label,
        "width": item.width
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-column",
    attrs: {
      "slot": "column"
    },
    slot: "column"
  }, [(_vm.multiple) ? _c('div', {
    ref: "lookupDrawer",
    staticClass: "column-wrapper",
    class: [
      _vm.column ? 'column-card' : '',
      _vm.hideDrawer ? 'column-no-bg' : 'column-bg'
    ]
  }, [(_vm.drawerSearch) ? _c('rt-search', {
    staticClass: "select-search",
    attrs: {
      "more": false,
      "clearable": _vm.clearable
    },
    on: {
      "on-search": _vm.searchSelect,
      "clear": _vm.clearSearchValue
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select-title"
  }, [(_vm.isSearch) ? _c('div', {
    staticClass: "select-num"
  }, [_vm._v("\n          " + _vm._s(_vm.$tx(
    ("已选择 " + (_vm.selectList.length) + " 项，为你搜到 " + (_vm.searchList.length) + " 项"),
    'xpc.lookup.searchItems', {
      count: _vm.selectList.length,
      search: _vm.searchList.length
    }
  )) + "\n        ")]) : _c('div', {
    staticClass: "select-num"
  }, [_vm._v("\n          " + _vm._s(_vm.$tx(
    ("已选择 " + (_vm.selectList.length) + " 项"),
    'xpc.lookup.selectedItems', {
      count: _vm.selectList.length
    }
  )) + "\n        ")]), _vm._v(" "), (_vm.searchList.length > 0) ? _c('rt-popconfirm', {
    attrs: {
      "title": _vm.$tx('确定需要全部删除吗？', 'xpc.common.confirmDeleteAll')
    },
    on: {
      "confirm": _vm.clear
    }
  }, [_c('rt-button', {
    attrs: {
      "slot": "reference",
      "text": "",
      "type": "plain"
    },
    slot: "reference"
  }, [_vm._v("\n            " + _vm._s(_vm.$tx('一键清空', 'xpc.dialog.oneClickClear')) + "\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "selected-content",
    class: {
      'selected-content-default-image': !_vm.selectList.length
    }
  }, [_vm._l((_vm.searchList), function(item, index) {
    return _c('div', {
      key: item[_vm.alias.id],
      staticClass: "selected"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatItemHandler(item))
      }
    }), _vm._v(" "), _c('rt-popconfirm', {
      attrs: {
        "title": _vm.$tx('确定需要删除这条内容吗？', 'xpc.common.comfirmDelete')
      },
      on: {
        "confirm": function($event) {
          return _vm.delTag(index, item)
        }
      }
    }, [_c('rt-icon', {
      attrs: {
        "slot": "reference",
        "name": "rt-base-close-x"
      },
      slot: "reference"
    })], 1)], 1)
  }), _vm._v(" "), _c('rt-default-image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectList.length === 0),
      expression: "selectList.length === 0"
    }]
  }, [_c('div', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_vm._v("\n            " + _vm._s(_vm.$tx('暂无数据', 'xpc.uploadfile.nodata')) + "\n          ")])])], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rt-dialog-footer-left",
    attrs: {
      "slot": "footer-left"
    },
    slot: "footer-left"
  }, [_vm._t("footer-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-dialog-footer-right",
    attrs: {
      "slot": "footer-right"
    },
    slot: "footer-right"
  }, [_c('rt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tx('确认', 'xpc.dialog.confirm')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-734dd0d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/lookup/rtLookupView.vue
// module id = 2186
// module chunks = 137